var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("span", {
    class: _vm.iconClass,
    on: {
      click: function ($event) {
        $event.stopPropagation()
        return _vm.openUrl.apply(null, arguments)
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }